import React from 'react';
import CmRuleGovernance from '../../../components/monitoring/CmRuleGovernance';
import CmResultsView from '../../../components/monitoring/CmResultsView';
import CmPreprocessing from '../../../components/monitoring/CmPreprocessing';
import EventsTab from '../../../components/monitoring/EventsTab';
import AnalyticsTab from '../../../components/monitoring/AnalyticsTab';
import '../../../components/layout/ModuleLayout.css';
import { MonTabKey } from './MonitoringTabs';

interface MonitoringNetBodyProps {
  activeTab?: MonTabKey;
  onTabChange?: (key: MonTabKey) => void;
}

const MonitoringNetBody: React.FC<MonitoringNetBodyProps> = ({ activeTab = 'insights', onTabChange }) => {
  const renderPanel = () => {
    if (activeTab === 'insights')  return <AnalyticsTab />;
    if (activeTab === 'sources')   return <CmRuleGovernance key="cm-data-sources" section="data_sources" />;
    if (activeTab === 'preprocessing') return <CmPreprocessing />;
    if (activeTab === 'rules')     return <CmRuleGovernance key="cm-rules" section="rules" />;
    if (activeTab === 'results')   return <CmResultsView />;
    if (activeTab === 'events')    return <EventsTab />;
    return (
      <div className="coming-soon">
        <span className="soon-badge">Coming soon</span>
        <p>This feature is under development.</p>
      </div>
    );
  };

  return (
    <div className="module-layout">
      <div className="module-main">
        <div className="tab-content">
          <section role="tabpanel" className="tab-panel show">
            {renderPanel()}
          </section>
        </div>
      </div>
    </div>
  );
};

export default MonitoringNetBody;
